/* unplugin-vue-components disabled */import script from "./StudentEvaDrawer.vue?vue&type=script&setup=true&name=StudentEvaDrawer&lang=js"
export * from "./StudentEvaDrawer.vue?vue&type=script&setup=true&name=StudentEvaDrawer&lang=js"

import "./StudentEvaDrawer.vue?vue&type=style&index=0&id=e8ff7cf0&lang=scss&scoped=true"
import "./StudentEvaDrawer.vue?vue&type=style&index=1&id=e8ff7cf0&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8ff7cf0"]])

export default __exports__